import React, { Fragment } from "react";
import { useSelector } from "react-redux";
import { Button } from "@progress/kendo-react-buttons";
import {
    updateDashboard,
    getDashboardExportSelector,
    getDashboardResetSelector, getDashboardPositionDataSelector
} from "../Slices/DashboardSlice";
import { useAppDispatch } from "../../Core/store.hooks";
const Filters = () => {
    const exportCounter = useSelector(getDashboardExportSelector);
    const resetCounter = useSelector(getDashboardResetSelector);
    const savedPositionData = useSelector(getDashboardPositionDataSelector)
    const dispatch = useAppDispatch();
    const exportDashboardHandler = () => {
        dispatch<any>(
            updateDashboard({
                resetCounter: resetCounter,
                exportCounter: exportCounter + 1,
                positionData:savedPositionData,
            })
        );
    };
    const resetDashboardHandler = () => {
        dispatch<any>(
            updateDashboard({
                resetCounter: resetCounter + 1,
                exportCounter: exportCounter,
                positionData: savedPositionData,
            })
        );
    };
    function renderContent() {
        return (
            <Fragment>
                    <Button
                        className=" pp-filter-button"
                        onClick={resetDashboardHandler}
                    >
                        Reset Dashboard
                    </Button>
                    <Button
                        className=" pp-filter-button"
                        onClick={exportDashboardHandler}
                    >
                        Export Dashboard
                    </Button>
            </Fragment>
        );
    }
    return <Fragment>{renderContent()}</Fragment>;
};
export default Filters;